(() => {
  'use strict';
  function eligible(tags, c) {
    const {gender:genderParam='',grade:gradeParam='',program:programParam='',sport=''} = c.values;
    const collectionHandle = c.school;
    const sasTeam = collectionHandle === 'st-anthony-school' && programParam === 'team';
    let selectedSport = sport;
    if (sasTeam && !['basketball','volleyball'].includes(selectedSport)) selectedSport = '';
      let show = true;
      if (genderParam || gradeParam || programParam) {
        if (programParam) {
          if (!tags.includes('program-' + programParam)) show = false;
        }
        if (show && genderParam) {
          if (!tags.includes('program-spiritwear') && !tags.includes('program-team') && !tags.includes('program-drama')) {
            const schoolGenderGradePrefix = 'school-' + collectionHandle + '-gender-' + genderParam + '-grade-';
            const hasSchoolGenderGrade = tags.some(t => t.startsWith(schoolGenderGradePrefix));
            let schoolGradeMatched = false;
            let useGenericFallback = false;
            if (hasSchoolGenderGrade) {
              if (gradeParam) {
                const schoolGenderGradeTag = 'school-' + collectionHandle + '-gender-' + genderParam + '-grade-' + gradeParam;
                if (tags.includes(schoolGenderGradeTag)) {
                  schoolGradeMatched = true;
                } else {
                  useGenericFallback = true;
                }
              } else {
                useGenericFallback = true;
              }
            } else {
              const schoolGenderPrefix = 'school-' + collectionHandle + '-gender-';
              const hasSchoolGender = tags.some(t => t.startsWith(schoolGenderPrefix));
              if (hasSchoolGender) {
                const schoolGenderTag = 'school-' + collectionHandle + '-gender-' + genderParam;
                if (tags.includes(schoolGenderTag)) {
                  if (gradeParam) {
                    const schoolGradePrefix = 'school-' + collectionHandle + '-grade-';
                    const hasSchoolGrade = tags.some(t => t.startsWith(schoolGradePrefix));
                    if (hasSchoolGrade) {
                      if (!tags.includes('school-' + collectionHandle + '-grade-' + gradeParam)) show = false;
                    }
                  }
                } else {
                  show = false;
                }
              } else {
                useGenericFallback = true;
              }
            }
            if (useGenericFallback) {
              const genderPrefix = 'gender-' + genderParam + '-';
              const simpleGenderTag = 'gender-' + genderParam;
              const hasCombined = tags.some(t => t.startsWith(genderPrefix));
              if (hasCombined) {
                if (gradeParam) {
                  if (!tags.includes('gender-' + genderParam + '-' + gradeParam)) show = false;
                }
              } else if (tags.includes(simpleGenderTag)) {
                if (gradeParam) {
                  if (!tags.includes('grade-' + gradeParam)) show = false;
                }
              } else {
                show = false;
              }
            }
          }
        }
      }
      if (show && programParam === 'team' && selectedSport && selectedSport !== 'all-sports' && !tags.includes('sport-' + selectedSport)) show = false;
      if (show && sasTeam && !selectedSport) show = false;

    return show;
  }
  function coherent(c, lines, directory) {
    if (!c?.complete || !Array.isArray(lines)) return false;
    return lines.every(line => {
      if (!Array.isArray(line.schools) || !Array.isArray(line.tags)) return false;
      const schools = line.schools.filter(s => directory.has(s));
      if (schools.length) return schools.includes(c.school);
      return !line.tags.some(t => t.startsWith('school-'));
    });
  }
  window.LiebmansSchoolEligibility = {eligible, coherent};
})();
